// Theme: Dark (Default) / Light. Sofort aus localStorage (kein Aufblitzen),
// danach serverseitig aus app_settings.ui_theme, damit Handy und Rechner gleich sind.
import { useCallback, useEffect, useState } from "react";
import { apiClient } from "../api/client";

export type Theme = "dark" | "light";

const read = (): Theme => {
  try { return localStorage.getItem("theme") === "light" ? "light" : "dark"; } catch { return "dark"; }
};

const apply = (t: Theme) => {
  document.documentElement.setAttribute("data-theme", t);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", t === "light" ? "#fafaf9" : "#101112");
  try { localStorage.setItem("theme", t); } catch { /* privater Modus */ }
};

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(read);

  useEffect(() => { apply(theme); }, [theme]);

  useEffect(() => {
    apiClient.get("/settings/ui_theme")
      .then(r => { if (r.data?.value === "light" || r.data?.value === "dark") setTheme(r.data.value); })
      .catch(() => { /* offline: lokaler Wert bleibt */ });
  }, []);

  const toggle = useCallback(() => {
    setTheme(t => {
      const next: Theme = t === "dark" ? "light" : "dark";
      apiClient.put("/settings/ui_theme", { value: next }).catch(() => {});
      return next;
    });
  }, []);

  return { theme, toggle };
}
